import productsLayoutVariables from '@/domains/productDiscovery/Listings/components/ProductsLayout/variables.module.scss';
import productRevampedLayoutVariables from '@/domains/productDiscovery/Listings/styles/layout.module.scss';

// technical layout
export const isThreeColumnsMobileRevampedQuery = `(min-width: ${
  productRevampedLayoutVariables.threeColumnsMobile
}) and
(max-width: ${
  parseInt(productRevampedLayoutVariables.fourColumnsMobile, 10) - 1
}px)`;
export const isFourColumnsMobileRevampedQuery = `(min-width: ${
  productRevampedLayoutVariables.fourColumnsMobile
}) and
(max-width: ${
  parseInt(productRevampedLayoutVariables.threeColumnsDesktop, 10) - 1
}px)`;
export const isThreeColumnsDesktopRevampedQuery = `(min-width: ${
  productRevampedLayoutVariables.threeColumnsDesktop
}) and
(max-width: ${
  parseInt(productRevampedLayoutVariables.fourColumnsDesktop, 10) - 1
}px)`;
export const isFourColumnsDesktopRevampedQuery = `(min-width: ${productRevampedLayoutVariables.fourColumnsDesktop})`;

// goodDeal layout
export const isTwoColumnsQuery = `(min-width: ${
  productsLayoutVariables.twoColumnMinWidth
}) and
(max-width: ${
  parseInt(productsLayoutVariables.threeColumnWithSidebarMinWidth, 10) - 1
}px)`;
export const isThreeColumnsQuery = `(min-width: ${productsLayoutVariables.threeColumnWithSidebarMinWidth})`;

// inspirational cards layout
export const isInspirationalTwoColumnsMobileQuery = `(min-width: ${
  productRevampedLayoutVariables.inspirationalTwoColumnsMobile
}) and
(max-width: ${
  parseInt(productRevampedLayoutVariables.inspirationalThreeColumnsMobile, 10) -
  1
}px)`;
export const isInspirationalThreeColumnsMobileQuery = `(min-width: ${
  productRevampedLayoutVariables.inspirationalThreeColumnsMobile
}) and
(max-width: ${
  parseInt(productRevampedLayoutVariables.inspirationalTwoColumnsDesktop, 10) -
  1
}px)`;

export const isInspirationalTwoColumnsDesktopQuery = `(min-width: ${
  productRevampedLayoutVariables.inspirationalTwoColumnsDesktop
}) and
(max-width: ${
  parseInt(
    productRevampedLayoutVariables.inspirationalThreeColumnsDesktop,
    10,
  ) - 1
}px)`;
export const isInspirationalThreeColumnsDesktopQuery = `(min-width: ${productRevampedLayoutVariables.inspirationalThreeColumnsDesktop})`;

export const productsByRowCalculator = (
  isGoodDeals: boolean,
  inspirationalProductCardsEnabled: boolean,
): number => {
  let productsByRow = 1;

  // technical Layout
  const isThreeColumnsMobileRevamped = window.matchMedia(
    isThreeColumnsMobileRevampedQuery,
  ).matches;
  const isFourColumnsMobileRevamped = window.matchMedia(
    isFourColumnsMobileRevampedQuery,
  ).matches;
  const isThreeColumnsDesktopRevamped = window.matchMedia(
    isThreeColumnsDesktopRevampedQuery,
  ).matches;
  const isFourColumnsDesktopRevamped = window.matchMedia(
    isFourColumnsDesktopRevampedQuery,
  ).matches;

  if (!isGoodDeals && !inspirationalProductCardsEnabled) {
    if (isFourColumnsDesktopRevamped || isFourColumnsMobileRevamped) {
      productsByRow = 4;
    } else if (isThreeColumnsDesktopRevamped || isThreeColumnsMobileRevamped) {
      productsByRow = 3;
    } else {
      productsByRow = 2;
    }
  }

  // goodDeal layout
  const isTwoColumns = window.matchMedia(isTwoColumnsQuery).matches;
  const isThreeColumns = window.matchMedia(isThreeColumnsQuery).matches;

  if (isGoodDeals) {
    if (isThreeColumns) {
      productsByRow = 3;
    } else if (isTwoColumns) {
      productsByRow = 2;
    } else {
      productsByRow = 1;
    }
  }

  // inspirational cards layout
  const isInspirationalTwoColumns =
    window.matchMedia(isInspirationalTwoColumnsMobileQuery).matches ||
    window.matchMedia(isInspirationalTwoColumnsDesktopQuery).matches;

  const isInspirationalThreeColumns =
    window.matchMedia(isInspirationalThreeColumnsMobileQuery).matches ||
    window.matchMedia(isInspirationalThreeColumnsDesktopQuery).matches;

  if (inspirationalProductCardsEnabled) {
    if (isInspirationalTwoColumns) productsByRow = 2;
    else if (isInspirationalThreeColumns) productsByRow = 3;
    else productsByRow = 1;
  }

  return productsByRow;
};
